import { render } from "./CardThirtyThree.vue?vue&type=template&id=173daf3c"
import script from "./CardThirtyThree.vue?vue&type=script&lang=js"
export * from "./CardThirtyThree.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__